export default {
    common: {
        documentTitle: "岱恩教育-學員端",
        close: "關 閉",
        confirm: '確 定',
        cancel: '取 消',
        cancelApp: '取消',
        changetime: '更改時間',
        login: '登 錄',
        submit: "提交",
        nodata: "暫無數據",
        noTime: "暫無可選時間",
        noSession: "暫無會話記錄",
        return: "返 回 ",
        logout: "退" + '\xa0\xa0\xa0' + "出",
        giveup: "放 棄",
        iSee: "知道了",
        refreshSuc: "刷新成功",
        clearSuc: "清除成功",
        settingSuc: "設置成功",
        finish: "完 成",
        other: "其他",
        index: "岱恩",
        titleTips: "提 示",
        nothing: "無",
        noDevelop: "暫未開發",
        shareTips: "請點擊右上角分享",
        daienEducation: "岱恩教育",
        and: "，",
        ended: "。",
        dollar: "元",
        download: "下 載",
        goConfirm: "去確認",
        noMore: "沒有更多了",
        loading: "加載中...",
        bind: '绑定',
        jumpHint: "即將從app跳轉AI天天練小程序，是否確認跳轉？",
        jumpHint1: "即將從app跳转竞赛小程序，是否確認跳轉？",
        newJ: "有新消息自動為您加載",
        jxjcancel: "已取消預約，使用的獎學金已返還至賬戶中",
        dd: "等",
        Reelection: "重選",
        copy: "複 製",
        copied: "複製成功",
        copyFailed: "複製失敗"
    },
    queryOralUser: {
        title: "请输入名称",
        cx: "查询",
        project: "请输入项目名称",
        teacher: "请输入姓名/昵称/地区",
        examPublish: '请输入考试名称'
    },
    daiEnStudent: {
        title: "请输入手机号/姓名",
    }
}


// WEBPACK FOOTER //
// ./src/lang/tw.js